import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const gallerySlice = createSlice({
  name: "gallery",
  initialState: {
    gallery: {
      data: [],
      loading: false,
      error: null,
    },
    CQA: {
      data: [],
      loading: false,
      error: null,
    },
    CQADescription: {
      data: [],
      loading: false,
      error: null,
    },
    news: {
      data: [],
      loading: false,
      error: null,
    },
    video: {
      data: [],
      loading: false,
      error: null,
    },
  },
  reducers: {
    fetchGalleryStart(state) {
      state.gallery.loading = true;
      state.gallery.error = false;
    },
    fetchGallerySuccess(state, action) {
      state.gallery.loading = false;
      state.gallery.data = action.payload;
    },
    fetchGalleryFailure(state, action) {
      state.gallery.loading = false;
      state.gallery.error = action.payload;
    },
    fetchCQAStart(state) {
      state.CQA.loading = true;
      state.CQA.error = false;
    },
    fetchCQASuccess(state, action) {
      state.CQA.loading = false;
      state.CQA.data = action.payload;
    },
    fetchCQAFailure(state, action) {
      state.CQA.loading = false;
      state.CQA.error = action.payload;
    },
    fetchNewsStart(state) {
      state.news.loading = true;
      state.news.error = false;
    },
    fetchNewsSuccess(state, action) {
      state.news.loading = false;
      state.news.data = action.payload;
    },
    fetchNewsFailure(state, action) {
      state.news.loading = false;
      state.news.error = action.payload;
    },

    fetchVideoStart(state) {
      state.video.loading = true;
      state.video.error = false;
    },
    fetchVideoSuccess(state, action) {
      state.video.loading = false;
      state.video.data = action.payload;
    },
    fetchVideoFailure(state, action) {
      state.video.loading = false;
      state.video.error = action.payload;
    },

    fetchCQADescriptionStart(state) {
      state.CQADescription.loading = true;
      state.CQADescription.error = false;
    },
    fetchCQADescriptionSuccess(state, action) {
      state.CQADescription.loading = false;
      state.CQADescription.data = action.payload;
    },
    fetchCQADescriptionFailure(state, action) {
      state.CQADescription.loading = false;
      state.CQADescription.error = action.payload;
    },
  },
});

export const {
  fetchGalleryStart,
  fetchGallerySuccess,
  fetchGalleryFailure,
  fetchCQAStart,
  fetchCQASuccess,
  fetchCQAFailure,
  fetchNewsStart,
  fetchNewsSuccess,
  fetchNewsFailure,
  fetchVideoStart,
  fetchVideoSuccess,
  fetchVideoFailure,
  fetchCQADescriptionStart,
  fetchCQADescriptionSuccess,
  fetchCQADescriptionFailure
} = gallerySlice.actions;


export const fetchCQADescriptionData = () => async (dispatch) => {
  dispatch(fetchCQADescriptionStart());
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/galleryAndNews/getCQADesc`
    );
    const data = response.data.data || []; // Defaults to an empty array
    dispatch(fetchCQADescriptionSuccess(data));
  } catch (error) {
    dispatch(fetchCQADescriptionFailure(error.message || "Something went wrong"));
  }
};

export const fetchVideoGalleryData = () => async (dispatch) => {
  dispatch(fetchVideoStart());
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/galleryAndNews/getVideoAlbum`
    );
    const data = response.data.data || []; // Defaults to empty array if no data
    dispatch(fetchVideoSuccess(data));
  } catch (error) {
    dispatch(fetchVideoFailure(error.message || "Something went wrong"));
  }
};

export const fetchGalleryData = () => async (dispatch) => {
  dispatch(fetchGalleryStart());
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/galleryAndNews/getAlbum`
    );
    const data = response.data.data || []; // Defaults to empty array if no data
    dispatch(fetchGallerySuccess(data));
  } catch (error) {
    dispatch(fetchGalleryFailure(error.message || "Something went wrong"));
  }
};

export const fetchCQAData = () => async (dispatch) => {
  dispatch(fetchCQAStart());
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/galleryAndNews/getCQA`
    );
    const data = response.data.data || []; // Defaults to an empty array
    dispatch(fetchCQASuccess(data));
  } catch (error) {
    dispatch(fetchCQAFailure(error.message || "Something went wrong"));
  }
};

export const fetchNewsData = () => async (dispatch) => {
  dispatch(fetchNewsStart());
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/galleryAndNews/getNews`
    );
    const data = response.data.data || []; // Defaults to empty array if no data
    dispatch(fetchNewsSuccess(data));
  } catch (error) {
    dispatch(fetchNewsFailure(error.message || "Something went wrong"));
  }
};

export default gallerySlice.reducer;
